import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styles from './style.module.css';
import NamespaceDropdown from './NamespaceDropdown';
import NamespaceSearchModal from './NamespaceSearchModal';
import NaviButton from '../../compoenets/NaviButton';
import HowToMakeNs from '../HowToMakeNs';
import MyTask from './MyTask';

const urlMatchMenu={
    'task-list':1,
    'task-detail':1,
    'new-task-app':2,
    'new-task-device':2,
    'new-task-train':2,
    'model-catalog':3,
    'model-detail':3,
    'model-upload':4,
}

export default function Sidebar({className}){
    const location=useLocation();
    const [onMenu,setOnMenu]=useState(null);
    const [isNamespaceSearch,setIsNamespaceSearch]=useState(false);
    const [isHowToMakeNs,setIsHowToMakeNs]=useState(false);


    useEffect(()=>{
        const pathSeg=location.pathname.split('/');
        if(pathSeg[1]){
            setOnMenu(urlMatchMenu[pathSeg[1]])
        }
    },[location.pathname])
  
    const navigate=useNavigate();
    const viewNavigate=(newRoute)=>{
        if (!document.startViewTransition) {
          return navigate(newRoute);
        } else {
          return document.startViewTransition(() => {
            navigate(newRoute);
          });
        }
    }

    const handleClickMenu=(e)=>{
        e.stopPropagation();
        if(e==onMenu)return;
        const btn=e.currentTarget.querySelector('button');
        if(btn)btn.click();
    }

    return(
        <nav className={`${className} ${styles['wrap']}`}>
            <header className={styles['header']}>
              <span onClick={()=>{viewNavigate("/")}}>SAMUEL</span>
              <NamespaceDropdown 
                onSearch={()=>setIsNamespaceSearch(true)}
                onHow={()=>setIsHowToMakeNs(true)}
              />
            </header>
            <div className={styles['body']}>
                <ul className={styles['task-wrap']}>
                    <li>
                        <span>Task</span>
                    </li>
                    <li 
                    key={1}
                    className={`${onMenu===1&&styles['selected-menu']} ${styles['menu-item']}`}
                    onClick={handleClickMenu}>
                        <NaviButton to="/task-list">Task list</NaviButton>
                        <div className={styles['menu-tip']}>Task List</div>
                    </li>
                    <li 
                    key={2}
                    className={`${onMenu===2&&styles['selected-menu']} ${styles['menu-item']}`}
                    onClick={handleClickMenu}>
                        <NaviButton to="/new-task-app">New task</NaviButton>
                        <div className={styles['menu-tip']}>New Task</div>
                    </li>
                </ul>
                <ul className={styles['model-wrap']}>
                    <li><span>Model</span></li>
                    <li 
                    key={3}
                    className={`${onMenu===3&&styles['selected-menu']} ${styles['menu-item']}`}
                    onClick={handleClickMenu}>
                        <NaviButton to="/model-catalog">Model Catalog</NaviButton>
                        <div className={styles['menu-tip']}>Model Catalog</div>
                    </li>
                    <li 
                    key={4}
                    className={`${onMenu===4&&styles['selected-menu']} ${styles['menu-item']}`}
                    onClick={handleClickMenu}>
                        <NaviButton to="/model-upload">Upload Model</NaviButton>
                        <div className={styles['menu-tip']}>Upload Model</div>
                    </li>
                </ul>
                <ul className={styles['dataset-wrap']}>
                    <li>
                        <span>Dataset</span>
                        <span>Simulator</span>
                    </li>
                    <li
                    className={`${styles['menu-item']}`}>
                        <span>Data list</span>
                        <div className={styles['menu-tip']}>Coming</div>
                    </li>
                    <li
                    className={`${styles['menu-item']}`}>
                        <span>Create data</span>
                        <div className={styles['menu-tip']}>Coming</div>
                    </li>
                </ul>
            </div>
            <MyTask/>
        {isNamespaceSearch && <NamespaceSearchModal onClose={()=>setIsNamespaceSearch(false)}/>}
        {isHowToMakeNs && <HowToMakeNs onClose={()=>setIsHowToMakeNs(false)}/>}
        </nav>
    )
}